import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import config from '../../config'
import { orderBy } from 'lodash' // chain
import CSSModules from 'react-css-modules'
import Loader from 'react-loader'
import ReactTooltip from 'react-tooltip'
import container from '../../helpers/container'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import analytics from '../../helpers/analytics'
import {
  Chart,
  Link,
  LinkIcon,
  SocialButtons,
  FamilyGrid,
  GetStartedInput,
  GenderEqualityScoreLabel,
  Grade
} from '../../components'
import * as searchActions from 'redux/modules/search'
const Styles = require('./Family.css')


/**
 * <FamilyResults 
 *   fundFamily
 * />
 * 
 * Displays results for major fund families. Includes a chart, category
 * breakdowns, tweet button, and stats on ESG and fossil-free funds. Category
 * breakdowns are rendered by <FamilyResultsSectorDetails />.
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyResults extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundFamily: props.fundFamily || null
    }
  }

  render() {
    const { fundFamily } = this.state
    if (!fundFamily) { return null }

    const sriGreen = fundFamily.sri > 0 ? 'green' : 'black'
    const safeName = encodeURIComponent(fundFamily.name)
    const urlBase = config.routes.list + '?ff=' + safeName
    const sriUrl = urlBase + '&sri=1&srt=gef_score'

    const { gef_score_norm, gef_score } = fundFamily

    const overallScoreIcon = require( '../../../static/images/GEF-icons-gender-equality-score.svg' )

    let tip = `To calculate an average gender equality score for major fund
      managers, we:
      <ul style='padding-inline-start: 1px !important;'>
        <li>
          take each fund that's been scored by Gender Equality Funds
        </li>
        <li>
          average the overall gender equality scores, weighted by fund assets
          (so larger funds count more)
        </li>
      </ul>
      Below we've ranked the nine fund managers with the most assets scored by
      Gender Equality Funds by average overall gender equality score.`
    tip = format.tooltipHtml(tip)

    return (
      <div styleName='overall-wrap'>
        <div styleName='overall-container'>
          <div styleName='overall-score-container'>
            <div
              styleName='overall-score-container-inner'
              data-multiline
              data-effect='solid'
              data-place='bottom'
              data-for='family-score-container'
              data-html={true}
              data-event='click focus'
              ref='familyScoreContainer'
              data-tip={tip}
            >
              <div styleName='overall-score-title'>
                  <div styleName='icon-label-wrap'>
                    <img
                      src={overallScoreIcon}
                      alt='Average gender equality score'
                      styleName='inline-icon'
                    />
                    <div styleName='icon-label'>
                      Average gender equality score
                    </div>
                  </div>
              </div>
              <br/>
              <div styleName='overall-score-chart-wrap'>
                <div styleName='overall-score-chart'>
                  <Chart
                    gefScore={Math.round(gef_score_norm).toFixed(0)}
                    gefStyle={
                      format.scoreStyle(Math.round(gef_score_norm).toFixed(0))
                    }
                    type='large'
                  />
                </div>
                <div styleName='overall-score-text'>
                  <div styleName='overall-score-headline'>
                    Average overall score
                  </div>
                  <div styleName='overall-score-description'>
                    Weighted average of fund Overall Gender Scores
                  </div>
                </div>
              </div>
            </div>
            <ReactTooltip 
              id='family-score-container'
              globalEventOff='click'
              // afterShow={ () => { this.closeAllTooltipsExcept('familyScoreContainer') } }
            />
          </div>
          <div styleName='overall-sri-container'>
            <div styleName='overall-sri-container-inner'>
              <FamilyStatCount
                tip={
                  format.tooltipHtml(
                    'Number of funds analyzed and scored from this family.'
                  )
                }
                count={format.number(fundFamily.gef_num_funds)}
                label='funds scored'
              />

              { /* <FamilyStatCount
                tip={
                  format.tooltipHtml(
                    'Assets under management by funds analyzed from this ' +
                      'family.'
                  )
                }
                count={format.money(fundFamily.net_assets, true, 'USD', true, 1)}
                label='in assets analyzed'
              /> */ }

              <ReactTooltip id='flaggedfund-tooltip'/>
              { /* <Link
                to={sriUrl}
                title={
                  `${fundFamily.name} funds with sustainability mandates`
                }
              >
                <div
                  styleName={'stat ' + sriGreen}
                  data-multiline
                  data-effect='solid'
                  data-place='bottom'
                  data-for='sri-container'
                  data-html
                  data-scroll-hide
                  data-tip={
                    format.tooltipHtml(
                      `${fundFamily.name} has ${fundFamily.sri} scored 
                      ${format.maybePluralize(fundFamily.sri,'fund')}
                      reporting a Sustainability Mandate to Morningstar.`
                    )
                  }
                >
                  <div styleName='stat-count'>
                    {fundFamily.sri}
                  </div>
                  <div styleName='stat-label'>
                    <span style={{'whiteSpace':'nowrap'}}>
                      {format.maybePluralize(fundFamily.sri,'fund')} with
                      sustainability mandates
                      <LinkIcon/>
                    </span>
                  </div>
                </div>
              </Link> */ }

            </div>
            <ReactTooltip id='sri-container'/>
          </div>
        </div>

        <div styleName='chart-content-hl-wrap'>
          <p>
            <LinkIcon faclass='fa-info-circle' nospace />&nbsp;
            This data covers open-end mutual funds and exchange-traded funds
            domiciled in the
            U.S. with at least 50% of assets invested in stocks. It
            excludes bond funds, as well as
            closed-end funds, collective trusts, and funds domiciled
            outside the U.S.
          </p>
        </div>

        <FamilyRankingsList fundFamily={fundFamily} />

      </div>
    )
  }
}


/**
 * <FamilyStatCount
 *   fundFamily
 * />
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyStatCount extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tip: props.tip || null,
      count: props.count || null,
      label: props.label || null
    }
  }

  render() {
    const { tip, count, label } = this.state
    if (
      !tip ||
      !label
    ) { return null }

    return (
      <div
        styleName='stat'
        data-multiline
        data-effect='solid'
        data-tip={tip}
        data-html
        data-place='bottom'
        data-for='flaggedfund-tooltip'
      >
        <div styleName='stat-count'>{count}</div>
        <div styleName='stat-label'>{label}</div>
      </div>
    )
  }
}


/**
 * <FamilyRankingsList
 *   fundFamily
 *   fundFamilyList
 * />
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyRankingsList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundFamily: props.fundFamily || null
    }
  }

  render() {
    const { fundFamily } = this.state
    if (!fundFamily) { return null }

    const fundFamilyList = config.familyFunds

    const sorted = orderBy(fundFamilyList, ['gef_score_norm'], ['desc'])
    const activeArrow = require( '../../../static/images/active-arrow.svg' )

    return (
      <div styleName='family-ul-wrap'>
        <div styleName='family-ul-headline'>
          Scoring major fund managers
        </div>
        <div styleName='family-ul-lede'>
          See the average gender equality scores for the largest asset
          managers in our database.
        </div>
        <ul styleName='family-ul'>
          <li styleName='family-li-head'>
            <div styleName='family-li-name-head'>
              Fund manager
            </div>
            <div styleName='family-li-score-head'>
              Avg. fund score
            </div>
            { /* <div styleName='family-li-assets-head'>
              Amount invested in scored funds
            </div> */ }
          </li>
          {
            sorted.map((item, idx)=>{
              return (
                <li key={idx} >
                  <Link
                    to={config.routes.families+'?q='+item.name}
                    title={item.name}
                  >
                    <div
                      styleName={
                        item.name===fundFamily.name?'family-li active':'family-li'
                      }
                    >
                      <div styleName='family-li-name'>
                        {
                          item.name===fundFamily.name ?
                            <span>
                              <img
                                src={activeArrow}
                                alt={fundFamily.name}
                                styleName='arrow'
                              />
                              &nbsp;
                            </span> :
                            null
                        }
                        {item.name}
                      </div>
                      <div styleName='family-li-score'>
                        { Math.round((item.gef_score_norm + Number.EPSILON) * 10) / 10 }
                        &nbsp;
                        <span styleName='family-li-score-light'>
                          / 100 points
                        </span>
                      </div>
                      { /* <div styleName='family-li-assets'>
                        {format.money(item.net_assets)}
                      </div> */ }
                    </div>
                  </Link>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}


/**
 * <FamilyBanner
 *   fundFamily
 * />
 * 
 * Displays a banner for the fund family that has a different tagline if the
 * family is one of the 10 families with additional data in config, or just
 * a generic fund family.
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyBanner extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundFamily: props.fundFamily || null
    }
  }

  render() {
    const { fundFamily } = this.state
    if (!fundFamily) { return null }

    return (
      <div styleName='banner-wrap'>
        <div styleName='banner'>
          <div styleName='banner-inner'>
            <div styleName='banner-taglines'>
              <div>
                <div styleName='banner-tagline'>
                  {
                    fundFamily ?
                      (
                        <span>Are your retirement funds</span>
                      ) : (
                        <span>Your retirement plan could</span>
                      )
                  }
                </div>
              </div>
              <div>
                <div styleName='banner-tagline'>
                  {
                    fundFamily ?
                      (
                        <span>invested with {fundFamily.fund_family_label}?</span>
                      ) : (
                        <span>be funding gender inequality</span>
                      )
                  }
                </div>
              </div>
              <div styleName='toolkit'>
                <div styleName='toolkit-info'>
                  Check out our action toolkit and talk to your retirement
                  plan manager
                </div>
                <Link
                  to={config.routes.toolkit}
                  log={analytics.eventToToolkit()}
                  title='Gender-lens investing action toolkit'>
                  <div styleName='toolkit-action'>
                    Action toolkit<LinkIcon />
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


/**
 * <FamilySummarySentence
 *   fundFamily
 * />
 *
 * Displays sentence for the fund family that names the fund company
 * at the top of the list of funds and shareclasses for this family.
 *
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilySummarySentence extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundFamily: props.fundFamily || null
    }
  }

  render() {
    const { fundFamily } = this.state
    if (!fundFamily) { return null }

    return (
      <div styleName='summary'>
        {fundFamily.fund_family_label} funds in our database
      </div>
    )
  }
}


/**
 * <FamilyFundList
 *   fundList
 * />
 * 
 * Displays a list of funds for this family. Maps a fundList to a list of
 * FamilyFundListItem components.
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyFundList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fundList: props.fundList || null
    }
  }

  componentWillReceiveProps(props) {
    if (props.fundList) {
      this.setState({
        fundList: props.fundList
      })
    }
  }

  render() {
    const { fundList } = this.state
    if (!fundList) { return null }

    return (
      <div styleName='holding-list'>
        {
          fundList.map((fund, idx) => {
            return (
              <FamilyFundListItem
                fund={fund}
                key={'family-fund-list-item-'+idx}
              />
            )
          })
        }
      </div>
    )
  }
}


/**
 * <FamilyFundListItem 
 *   fund
 * />
 * 
 * Displays a fund in the list of funds for this family. Displays some summary
 * stats. Displays a list of tickers using the FamilyFundListItemTickerLinks
 * component.
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyFundListItem extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fund: props.fund || null
    }
  }

  render() {
    const { fund } = this.state
    if (!fund) { return null }

    const {
      fund_id,
      fund_legal_name,
      currency,
      grade_gender_equality
    } = fund

    const grp = fund.category_group

    // const grades = {
    //   gefOverallGroupGrade: format.gefGrade(
    //     format.gefScore(
    //       fund.gef_grp,
    //       config.gefScoreNormalizers.groups[grp],
    //       0,
    //       1,
    //       true
    //     )
    //   )
    // }

    // const activeGradeAsInt = format.gefGradeAsInt(grades.gefOverallGroupGrade)

    return (
      <div styleName='holding'>
        <div styleName='ticker-name-assets'>
          <div styleName='ticker-name'>
            <div styleName='holdings-name'>
              {fund_legal_name}
            </div>
            <FamilyFundListItemTickerLinks shareclasses={fund.shareclass} />
          </div>
        </div>
        
        <div styleName='score-wrapper'>
          Score
          <GenderEqualityScoreLabel fund={fund} gefType='gef_score'/>
        </div>
        <div styleName='score-wrapper'>
          Group rank
          <div styleName='col-center'>
            <GenderEqualityScoreLabel fund={fund} gefType='gef_grp'/>
            {
              fund['gef_grp'] != -1.0 ?
                <div styleName='reportcard-result-grade'>
                  <Grade grade={fund.grade_gender_equality} square/>
                </div> :
                null
            }
          </div>
        </div>

      </div>
    )
  }
}


/**
 * <FamilyFundListItemTickerLinks 
 *   shareclasses
 * />
 * 
 * Displays a list of tickers, linked to those shareclass profiles, for a fund
 * in the fund list. Maps a list of shareclasses to a list of URLs and
 * tickers. Maps the list of URLs and tickers to a list of Links.
 * 
 */
@CSSModules(Styles, {allowMultiple:true})
class FamilyFundListItemTickerLinks extends Component {
  constructor(props) {
    super(props)
    this.state = {
      shareclasses: props.shareclasses || null
    }
  }

  render() {
    const { shareclasses } = this.state
    if (!shareclasses) { return null }

    const tickerUrls = shareclasses.map((e,i)=>{
      const tckr = e.ticker || 'N/A'
      const safeTicker = e.ticker || 'N'
      const url = config.routes.fund + '/' +
        format.sanitize(e.fund_legal_name) + '/' + safeTicker + '/' +
        config.profilePath + '/' + e.fund_id + '/' + e.investment_vehicle_id

      return {
        ticker: tckr,
        name: e.name,
        url
      }
    })

    if (tickerUrls.length === 1 && tickerUrls[0].ticker === 'N/A') {
      const e = tickerUrls[0]
      return (
        <div styleName='ticker-links'>
            <Link to={e.url} title={e.name}>
              <span styleName='ticker'>See results<LinkIcon/></span>
            </Link>
        </div>
      )
    }

    return (
      <div styleName='ticker-links'>
        {
          tickerUrls.map((e, i)=>{
            return (
              <Link
                key={'holding-link-'+i}
                to={e.url}
                title={e.name}
              >
                { e.ticker === 'N/A' ?
                    <span styleName='ticker'>{e.name}</span> :
                    <span styleName='ticker'>{e.ticker}</span>
                }
              </Link>
            )
          })
        }
      </div>
    )
  }
}


@connect(
  state => ({
    result: state.familyShareClass.result,
    searching: state.familyShareClass.loading,
    searched: state.familyShareClass.loaded,
    error: state.familyShareClass.error,
    sector: state.sector.result
  }),
  searchActions)

@CSSModules(Styles, {allowMultiple:true})
export default class Family extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }

  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      family: props.location.query.q || '',
      searchQuery: '',
      lastResult: null,
      funds: [],
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.familyShareClasses(this.state.family, 1)
  }

  componentWillReceiveProps(props) {
    const q = props.location.query.q || ''
    if (q !== this.state.family) {
      this.familyShareClasses(q, 1)
      window.scroll(0, 0)
      this.setState({
        page: 1,
        family: q,
        searchQuery: '',
        lastResult: null,
        funds: [],
      })
    } else if (props.result && this.state.lastResult !== props.result){
      this.setState({
        lastResult: props.result,
        funds: this.state.funds.concat(props.result)
      })
    }
  }

  getMoreFunds = () => {
    this.familyShareClasses(this.state.family, this.state.page+1)
  }

  familyShareClasses = (family,page) => {
    page = page || this.state.page
    this.setState({page:page})
    this.props.familyShareClasses(family, page)
  }

  configFundFamily = () => {
    return config.familyFunds.find(
      family => family.name === this.state.family
    )
  }

  configEngagementFamily = () => {
    return config.engagementFunds.find(
      family => family.name === this.state.family
    )
  }

  render() {
    if (!(this.state.page !== 1 || !this.props.searching)) {
      return (
        <div styleName='main'>
          <Loader options={{scale: 0.70, top:'2.0rem'}} loaded={false}/>
        </div>
      )
    }

    if (!this.props.location.query.q) {
      return (
        <div styleName='main'>
          <FamilyGrid fullGrid/>
        </div>
      )
    }

    const { funds } = this.state

    const fundFamily = this.configFundFamily()

    const fileName = format.imgPath(this.state.family)
    let hasLogo = false
    let companyLogo = null
    try {
      companyLogo = require('../../../static/images/fam/'+fileName+'.png')
      hasLogo = true
    }
    catch (e) {
      console.log('')
    }

    const hasMore = (
      this.state.lastResult &&
      this.state.lastResult.length === config.queryMaxFunds
    )

    //
    return (
      <div styleName='main'>
        {container.helmet(this.state.family || 'Major asset managers')}
        <Loader
          options={{scale: 0.70, top: '2.0rem'}}
          loaded={this.state.page !== 1 || !this.props.searching}
        >
          <div styleName='snapshot-wrapper'>
            <div styleName='snapshot'>

              <div styleName='name-wrap'>
                <div styleName='name'>
                  <div styleName={fundFamily ? 'name-tag-big' : 'name-tag'}>
                    {fundFamily ? 'Major fund manager' : 'Fund manager'}
                  </div>
                </div>
                <div>
                  { 
                    fundFamily ?
                      (
                        <SocialButtons
                          message={config.app.title+' - '+fundFamily.name}
                          link={config.routes.families+'?q='+this.state.family}
                        />
                      ) :
                      null
                  }
                </div>
              </div>

              {
                hasLogo ?
                  (
                     <div styleName='name-logo'>
                       <div styleName='name-logo-lbl'>
                        {
                          fundFamily ?
                            fundFamily.label :
                            this.state.family
                        }
                      </div>
                      <img
                        styleName='name-logo-img'
                        src={companyLogo}
                        alt={
                          fundFamily ?
                            fundFamily.label :
                            this.state.family
                        }
                      />
                     </div>
                  ) :
                  (
                    <span>{this.state.family}</span>
                  )
              }

              <FamilyResults fundFamily={fundFamily} />
              
            </div>
          </div>
          <div styleName='holdings-wrapper'>
            <div styleName='holdings'>
              <FamilySummarySentence fundFamily={fundFamily}/>
              <div styleName='holdings-inner'>
                <div styleName='rating-label'>
                  <div styleName='rating-label-line'/>
                  <div styleName='rating-label-info'>
                    Gender equality score
                  </div>
                </div>
                <FamilyFundList fundList={funds} />
              </div>
            </div>
          </div>
          
          <div styleName='more-funds-wrapper'>
            <Loader
              options={{scale: 0.70, top:'0'}}
              loaded={ !this.props.searching }
            />
            <div styleName='more-funds'>
              <div
                onClick={hasMore ? this.getMoreFunds : null}
                styleName={
                  hasMore ? 'more-funds-button' : 'no-more-funds-button'
                }
              >
                {
                  hasMore ?
                    'Get more funds' : 
                    'No more funds'
                }<LinkIcon faclass='fa-plus-circle'/>
              </div>
              {
                !hasMore ?
                  (
                    <div styleName='no-more-funds-info'>
                      Looking for your favorite fund and can't find it? Sorry,
                      but we don't have everything in our database.
                    </div>
                  ) :
                  null
              }
            </div>
          </div>

          <GetStartedInput />
          
          <FamilyBanner fundFamily={fundFamily}/>

        </Loader>
      </div>
    )
  }
}
